/**
 * Cihaz tipi kodundan görünen isim — **tek doğruluk kaynağı**.
 *
 * ## Neden
 *
 * Bu eşleme depoda **altı kopya** halinde duruyordu ve kopyalar ayrışmıştı:
 *
 * | Dosya | Fonksiyon | İçerik |
 * |---|---|---|
 * | `LiveGraphic` | `nameChooserForUI` | uzun adlar |
 * | `LiveGraphic` | `nameChooser` | **kısa** adlar |
 * | `AnalysisDocument` · `GraphicDocuments` · `TableDocuments` | `nameChooserForUI` | uzun adlar |
 * | aynı üç dosya | `nameChooser` | kısa adlar, **hiç çağrılmıyor** |
 * | `ElfatekDeviceList` | `nameChooser` | uzun adlar **+ tip 8** |
 * | `ExcelDevices` | `excelCihazAdi` | uzun adlar |
 *
 * Yani aynı cihaz, hangi ekranda olduğuna göre iki ayrı isim taşıyordu ("Aşırı Yük
 * İndikatörü" / "İndikatör") ve tip 8 yalnızca tek ekranda isimlendiriliyordu.
 *
 * ## İki ayrı eşleme bilerek korunuyor
 *
 * Uzun adlar listelerde ve seçim kutularında, kısa adlar ise `LiveGraphic`'teki grafik
 * başlığı gibi yerin kısıtlı olduğu noktalarda kullanılıyor. Bunları birleştirmek
 * ekranların görünümünü değiştirirdi; kopyaları teke indirmek yeterli.
 */

/** Uzun ad — listeler, seçim kutuları. */
export function cihazAdi(kod: unknown): string {
  switch (String(kod)) {
    case "1": return "Çift Yük Hücreli Aşırı Yük İndikatör"
    case "2": return "Aşırı Yük İndikatörü"
    case "3": return "Açı Limit Sensörü"
    case "4": return "Canio"
    case "5": return "Fren"
    case "7": return "Mesafe Sensör"
    // Tip 8 yalnızca `ElfatekDeviceList`'te isimlendiriliyordu; diğer ekranlarda BOŞ
    // görünüyordu (`undefined` dönüyordu). `TableDocuments` tip 8'i tanıyor
    // (`setGraphicTypeList(kugu)`), yani seçim kutusunda isimsiz bir satır çıkıyordu.
    // Metin aynen korunuyor ("kugu", küçük harf): değiştirmek ekranda görüneni
    // değiştirmek olurdu.
    case "8": return "kugu"
    // Önceden burada DÖNÜŞ YOKTU: tanınmayan tipte `undefined` dönüyor ve listede
    // "3-" gibi isimsiz bir satır görünüyordu.
    default: return `Bilinmeyen cihaz tipi (${String(kod)})`
  }
}

/** Kısa ad — yerin kısıtlı olduğu yerler (ör. grafik başlığı). */
export function cihazKisaAdi(kod: unknown): string {
  switch (String(kod)) {
    case "1": return "Çift giriş indikatör"
    case "2": return "İndikatör"
    case "3": return "Halat açı"
    case "4": return "Canio"
    case "5": return "Fren"
    // "Mesafe Sensörü" -- uzun eşlemedeki "Mesafe Sensör"den farklı; ikisi de aynen
    // korunuyor.
    case "7": return "Mesafe Sensörü"
    default: return `Bilinmeyen (${String(kod)})`
  }
}
